import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const pathStart = 'Tools|Announcements|List|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.Announcements,
	portal: 'SP',
};
const columnHeadingDescriptionStart = 'Column heading for: ';

type LocNameStart = 'SPAnnouncementsList';
export type SPAnnouncementsListLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelHeadline`
	| `${LocNameStart}LabelCreated`
	| `${LocNameStart}LabelStarts`
	| `${LocNameStart}LabelEnds`
	| `${LocNameStart}LabelViews`
	| `${LocNameStart}LabelReads`
	| `${LocNameStart}LabelSummary`
	| `${LocNameStart}ButtonCreateAnnouncement`
	| `${LocNameStart}LabelNewsDisplayOrder`;

export const spAnnouncementsListLocs: LocDefs<SPAnnouncementsListLocNames> = {
	SPAnnouncementsListTitlePage: {
		defaultValue: 'Announcements',
		description: 'Page Title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Announcements/Tools.Announcements.Title.PageTitle',
		...sharedProperties,
	},
	SPAnnouncementsListLabelHeadline: {
		defaultValue: 'Headline',
		description: `${columnHeadingDescriptionStart}Headline.`,
		displayPath: `${pathStart}Headline`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.Headline',
		...sharedProperties,
	},
	SPAnnouncementsListLabelCreated: {
		defaultValue: 'Created Date',
		description: `${columnHeadingDescriptionStart}Created Date.`,
		displayPath: `${pathStart}Created Date`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.CreatedDate',
		...sharedProperties,
	},
	SPAnnouncementsListLabelStarts: {
		defaultValue: 'Start Date',
		description: `${columnHeadingDescriptionStart}Start Date.`,
		displayPath: `${pathStart}Start Date`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.StartDate',
		...sharedProperties,
	},
	SPAnnouncementsListLabelEnds: {
		defaultValue: 'End Date',
		description: `${columnHeadingDescriptionStart}End Date.`,
		displayPath: `${pathStart}End Date`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.EndDate',
		...sharedProperties,
	},
	SPAnnouncementsListLabelViews: {
		defaultValue: 'Views',
		description: `${columnHeadingDescriptionStart}Views.`,
		displayPath: `${pathStart}Views`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.Views',
		...sharedProperties,
	},
	SPAnnouncementsListLabelReads: {
		defaultValue: 'Reads',
		description: `${columnHeadingDescriptionStart}Reads.`,
		displayPath: `${pathStart}Reads`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.Reads',
		...sharedProperties,
	},
	SPAnnouncementsListLabelSummary: {
		defaultValue: 'Summary',
		description: `${columnHeadingDescriptionStart}Summary.`,
		displayPath: `${pathStart}Summary`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.ColumnHeading.Summary',
		...sharedProperties,
	},
	SPAnnouncementsListButtonCreateAnnouncement: {
		defaultValue: 'Create New Announcement',
		description: `Button to Create New Announcement.`,
		displayPath: `${pathStart}Create New Announcement`,
		displayType: 'Label',
		legacyName: 'Announcements/Tools.Announcements.Button.CreateNewAnnouncement',
		...sharedProperties,
	},
	SPAnnouncementsListLabelNewsDisplayOrder: {
		defaultValue: 'Display Order',
		description: `${columnHeadingDescriptionStart}Display Order.`,
		displayPath: `${pathStart}Display Order`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type SPAnnouncementsListLocType = LocMap<SPAnnouncementsListLocNames>;
